/**
 * Terminal wordmark: `$ remote-ai` with a blinking caret.
 */
export function Wordmark({
  size = 'md',
  caret = false,
}: {
  size?: 'sm' | 'md' | 'lg'
  caret?: boolean
}) {
  const cls = {
    sm: 'text-[15.5px]',
    md: 'text-[17.5px]',
    lg: 'text-[24px]',
  }[size]
  return (
    <span
      className={`inline-flex items-baseline gap-1.5 font-mono font-semibold tracking-tight text-fg ${cls}`}
    >
      <span className="text-accent">$</span>
      <span>remote-ai</span>
      {caret && <span className="caret" />}
    </span>
  )
}

// Back-compat stubs
export function Masthead({ compact: _compact = false }: { compact?: boolean }) {
  return null
}
